var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_c('UserList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }